(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("VueDemi"), require("FEGOBridge"), require("FEGOWebapi"), require("FEGORender"));
	else if(typeof define === 'function' && define.amd)
		define(["VueDemi", "FEGOBridge", "FEGOWebapi", "FEGORender"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/step-swiper/render"] = factory(require("VueDemi"), require("FEGOBridge"), require("FEGOWebapi"), require("FEGORender"));
	else
		root["/fego/component/step-swiper/render"] = factory(root["VueDemi"], root["FEGOBridge"], root["FEGOWebapi"], root["FEGORender"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__2309__, __WEBPACK_EXTERNAL_MODULE__7145__, __WEBPACK_EXTERNAL_MODULE__5113__, __WEBPACK_EXTERNAL_MODULE__5322__) => {
return 